import { withRouter } from 'common/withRouter';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import Utils from '../../utils/Utils';
import RouterConstants from '../RouterConstants';

const NamedRoute = ({
  title,
  component: Component,
  render,
  description,
  scriptType,
  keywords,
  script,
}) => (
  <div>
    <Helmet>
      <meta charSet="utf-8" />
      <title>
        {`${
          title
            ? `${title} - Enterpret`
            : 'Enterpret - Grok your customer’s feedback'
        }`}{' '}
      </title>
      <meta
        name="description"
        content={
          description ||
          'Enterpret will aggregate your customer feedback across all channels in one place. Our Machine Learning models can adjust to reviews/social media/conversations in over 50+ languages.'
        }
      />
      <meta name="author" content="Enterpret" />
      <meta
        name="keywords"
        content={
          keywords ||
          'Customer Feedback, Aggregated, Analysed, Shared real time, AI powered metrics, Feedback analysis, client feedbacks, Machine Learning models'
        }
      />
      {Utils.arrayCheck(script).map((it) => (
        <script type={scriptType}>{JSON.stringify(it)}</script>
      ))}
      <script type="application/ld+json">
        {`${RouterConstants.schemaForLandingPage}`}
      </script>
    </Helmet>
    {Component ? <Component /> : render()}
  </div>
);

NamedRoute.propTypes = {
  component: PropTypes.elementType,
  title: PropTypes.string,
  content: PropTypes.string,
  render: PropTypes.func,
  description: PropTypes.string,
  scriptType: PropTypes.string,
  keywords: PropTypes.string,
  script: PropTypes.arrayOf(PropTypes.object),
};

export default withRouter(NamedRoute);
